// @flow

import {toast} from "react-toastify"

import type {
  Task,
  TaskType,
  DateString,
  Action,
  ThunkAction,
  Dispatch,
} from "../types"
import {get, post, put, del} from "../client"
import i18n from "i18next"

export const fetchTasks = (babyToken: string): ThunkAction => {
  return (dispatch: Dispatch) => {
    return get(`/babies/${babyToken}/tasks`).then(response => {
      if (response.data) {
        dispatch(setTasks(response.data))
      } else {
        toast.error(i18n.t("toast.tasks.fetch.error"))
      }
    })
  }
}

export const setTasks = (tasks: $ReadOnlyArray<Task>): Action => ({
  type: "SET_TASKS",
  tasks,
})

export const addTask = (
  babyToken: string,
  description: string,
  type: TaskType,
  date: ?DateString
) => {
  return (dispatch: Dispatch) => {
    return post(`/babies/${babyToken}/tasks`, {description, type, date}).then(
      response => {
        if (response.data) {
          dispatch(setTasks(response.data))
        } else {
          toast.error(i18n.t("toast.tasks.fetch.error"))
        }
      }
    )
  }
}

export const updateTask = (babyToken: string, taskId: number, task: Task) => {
  return (dispatch: Dispatch) => {
    return put(`/babies/${babyToken}/tasks/${taskId}`, task).then(response => {
      if (response.data) {
        dispatch(setTasks(response.data))
      } else {
        toast.error(i18n.t("toast.tasks.put.error"))
      }
    })
  }
}

export const deleteTask = (babyToken: string, taskId: number) => {
  return (dispatch: Dispatch) => {
    return del(`/babies/${babyToken}/tasks/${taskId}`).then(response => {
      if (response.data) {
        dispatch(setTasks(response.data))
      } else {
        toast.error(i18n.t("toast.tasks.put.error"))
      }
    })
  }
}
